export class ApplicationUpdateDataModel {
    public offset = 0;
    public query = '';
    public limit = 100;
    public dateSentAtStart = '';
    public dateSentAtEnd = '';
    public sortByColumn = 'created';
    public sortDirection = 'desc';
    public statuses = [] as string[];
}
